import React from "react";
import PropTypes from "prop-types";

import styles from "./icon.css";

export const ICON_TYPES = {
  BASE: "base",
  TYPE2: "type2",
  TYPE3: "type3",
  TYPE4: "type4"
};

function Icon(props) {
  const {
    children,
    highlight = true,
    clickable,
    paddingNone,
    type = ICON_TYPES.BASE,
    onClick,
    onMouseEnter,
    onMouseLeave,
    focussed = false,
    className,
    ...restProps
  } = props;
  const paddingStyle = paddingNone ? 0 : undefined;
  return (
    <div
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={`${
        (onClick && highlight) || clickable ? styles.clickable : ""
      } ${styles.iconContainer} ${className} ${
        focussed ? styles.focussed : ""
      } ${styles[type]}`}
      onClick={onClick}
      style={{ padding: paddingStyle }}
      {...(onClick ? { role: "button" } : {})}
      {...restProps}
    >
      {children}
    </div>
  );
}

Icon.propTypes = {
  paddingNone: PropTypes.bool,
  type: PropTypes.string,
  highlight: PropTypes.bool,
  clickable: PropTypes.bool,
  children: PropTypes.element,
  className: PropTypes.string,
  onClick: PropTypes.func,
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  focussed: PropTypes.bool
};

export { Icon };
